// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__5FZ5s","opacity":"Modal_opacity__0MHos","success":"Modal_success__pW0TN","modal__title":"Modal_modal__title__d7s+U","text":"Modal_text__UBHfk"};